export interface RentPayment {
    id: string;
    paymentDate: Date;
    paymentMethod: PaymentMethod;
    totalAmount: number;
    paidAmount: number;
    dueAmount?: number;
    status: PaymentStatus;
    receiptPhoto?: string;
    notes?: string;
    processedBy?: number;
    isActive: boolean;
    createdAt: Date;
}

export interface CreateRentPayment {
    paymentMethod: PaymentMethod;
    paidAmount: number;
    paymentDate: string;
    apartmentId: string;
    tenantId: string;
    receiptPhoto?: File;
    notes?: string;
    processedBy?: number;
}

export enum PaymentMethod {
    efectivo = 1,
    transferencia = 2,
    tarjetaCredito = 3,
    tarjetaDebito = 4,
    sinpe = 5,
}

export enum PaymentStatus {
    pendiente = 1,
    pagado = 2,
    atrasado = 3,
    cancelado = 4,
}